import { mulberry32 } from '../../shared/seed';
import { WORDY_ANSWERS } from './data';

export type WordyPuzzle = {
  answer: string;
};

export function generateWordy(seed: number): WordyPuzzle {
  const random = mulberry32(seed);
  return { answer: WORDY_ANSWERS[Math.floor(random() * WORDY_ANSWERS.length)] };
}

export function isWordyPuzzle(value: unknown): value is WordyPuzzle {
  return (
    Boolean(value) &&
    typeof value === 'object' &&
    typeof (value as Partial<WordyPuzzle>).answer === 'string' &&
    WORDY_ANSWERS.includes((value as WordyPuzzle).answer)
  );
}
